import { render, staticRenderFns } from "./stuList.vue?vue&type=template&id=0ad8be82&scoped=true&"
import script from "./stuList.vue?vue&type=script&lang=js&"
export * from "./stuList.vue?vue&type=script&lang=js&"
import style0 from "./stuList.vue?vue&type=style&index=0&id=0ad8be82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad8be82",
  null
  
)

export default component.exports